var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"base-fieldset"},[(_vm.hasSlot('header'))?_c('div',{staticClass:"base-fieldset__header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:`base-fieldset__list base-fieldset__list--col-${_vm.col}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }